export default __webpack_public_path__ + "static/webRotator/svg/5cc13bad19dbef7c4cd2b10c3cfb18a3.svg";